import gql from 'graphql-tag';

export const destinationCarouselFragment = {
    RecommendedDestinationResponse: gql`
        fragment PropertyDestinationRecommendationResponse on RecommendedDestinationResponse {
            clientRequestId
            recommendedDestinations {
                searchTermUuid
                imageHref
                recommendationModel
                place {
                    name {
                        simple
                        full
                    }
                }
            }
        }
    `,
};
